// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-l_fT","catalogByServiceItem__title":"c-l_fU"};